module.exports = __webpack_public_path__ + "img/library-vlog-en.ac315f74.webp";